import StyledStack from "./styles";

const HorizontalScrollSection = StyledStack;

export default HorizontalScrollSection;
